import React from 'react'
import './SwipeSlider.css'
import Swipe from '../../../utils/swipe'

class SwipeSlider extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      visibleWidth: 0,
      childWidth: 0,
      hiddenWidth: 0,
      childCount: 0,
      leftDistance: 0
    }
    this.leftHandler = this.leftHandler.bind(this)
    this.rightHandler = this.rightHandler.bind(this)
  }

  leftHandler () {
    const {leftDistance, childWidth, visibleWidth, hiddenWidth} = this.state
    if (!(leftDistance < 0 && leftDistance >= (visibleWidth - hiddenWidth))) { return undefined }
    this.setState({leftDistance: -(Math.abs(leftDistance) - childWidth)})
  }

  rightHandler () {
    const {leftDistance, visibleWidth, hiddenWidth} = this.state
    if ((leftDistance <= (visibleWidth - hiddenWidth))) { return undefined }
    this.setState({leftDistance: this.state.leftDistance - this.state.childWidth})
  }

  componentDidMount () {
    this.setState({
      childWidth: this.refs.viewer.children[0].offsetWidth,
      childCount: this.props.children.length,
      visibleWidth: this.refs.swipe.offsetWidth
    }, () => {
      this.setState({
        hiddenWidth: this.state.childWidth * this.state.childCount,
        leftDistance: this.state.visibleWidth - this.state.childWidth * this.state.childCount
      })
    })

    let swipe = new Swipe('#swipe-slider')
    swipe.onLeft(() => this.rightHandler())
    swipe.onRight(() => this.leftHandler())
    swipe.run()
  }

  render () {
    const {height} = this.props
    const {hiddenWidth, leftDistance, visibleWidth} = this.state
    return (
      <div id="swipe-slider">
        <div ref="swipe" className="swipe-slider" style={height ? {height: `${height}px`} : {}}>
          <div ref="viewer" className="hidden-container" style={{width: `${hiddenWidth}px`, left: `${leftDistance}px`}}>
            {this.props.children}
          </div>

        </div>
        <a
          onClick={this.rightHandler}
          className={leftDistance > (visibleWidth - hiddenWidth) ? 'control-right' : 'hidden'}
          disabled={!(leftDistance > (visibleWidth - hiddenWidth))}
        ><span className="glyphicon glyphicon-chevron-right" /></a>
        <a
          onClick={this.leftHandler}
          className={leftDistance < 0 && leftDistance >= (visibleWidth - hiddenWidth) ? 'control-left' : 'hidden'}
          disabled={!(leftDistance < 0 && leftDistance >= (visibleWidth - hiddenWidth))}
        ><span className="glyphicon glyphicon-chevron-left" /></a>
      </div>
    )
  }
}

SwipeSlider.propTypes = {
  height: React.PropTypes.number,
  width: React.PropTypes.string
}

export default SwipeSlider



// WEBPACK FOOTER //
// ./src/components/Common/SwipeSlider/SwipeSlider.js